import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const renderIcon = (IconLike) => {
  if (!IconLike) {
    return null;
  }
  if (React.isValidElement(IconLike)) {
    return IconLike;
  }
  const IconComponent = IconLike;
  return <IconComponent />;
};

const OptionButtonGroup = ({
  options,
  gap,
  minWidth,
  buttonMinWidth,
  sx,
}) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      flexWrap: 'nowrap',
      gap,
      minWidth,
      ...sx,
    }}
  >
    {options.map((option) => {
      const {
        key,
        label,
        onClick,
        selected,
        startIcon,
        endIcon,
        selectedSx,
        defaultSx,
        selectedLabelSx,
        defaultLabelSx,
        buttonProps,
      } = option;
      const { sx: buttonPropsSx, ...restButtonProps } = buttonProps || {};
      const appliedButtonSx = selected ? selectedSx : defaultSx;
      const appliedLabelSx = selected ? selectedLabelSx : defaultLabelSx;

      const finalButtonSx = {
        ...appliedButtonSx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flex: 1,
        flexShrink: 0,
        minWidth: buttonMinWidth,
        gap: '8px',
        ...buttonPropsSx,
      };

      const finalLabelSx = {
        ...appliedLabelSx,
        textAlign: 'center',
      };

      return (
        <Button
          key={key}
          type="button"
          onClick={onClick}
          {...restButtonProps}
          sx={finalButtonSx}
        >
          {renderIcon(startIcon)}
          <Typography sx={finalLabelSx}>{label}</Typography>
          {renderIcon(endIcon)}
        </Button>
      );
    })}
  </Box>
);

OptionButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func,
      selected: PropTypes.bool,
      startIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
      endIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
      selectedSx: PropTypes.object,
      defaultSx: PropTypes.object,
      selectedLabelSx: PropTypes.object,
      defaultLabelSx: PropTypes.object,
      buttonProps: PropTypes.object,
    }),
  ).isRequired,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonMinWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object,
};

OptionButtonGroup.defaultProps = {
  gap: '12px',
  minWidth: '280px',
  buttonMinWidth: '140px',
  sx: {},
};

export default OptionButtonGroup;
